module.exports = __webpack_public_path__ + "img/121.e70fb2ea.jpg";